export default __webpack_public_path__ + "static/media/cancelar_cuenta.d0c1b6c5.svg";